import styled from "styled-components"

export const WhyAionContainer = styled.div`
  background-color: #def4fe;
  padding: 40px 0;
  background-image: url(${props => props.img});
  background-repeat: no-repeat;
  background-size: cover;
`

export const Wrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
`

export const MainContent = styled.div`
  h3 {
    color: ${props => props.theme.colors.darkBlue};
    max-width: 400px;
    margin-bottom: 26px;
    @media (max-width: 425px) {
      max-width: 330px;
    }
  }
  .main-text {
    margin-bottom: 26px;
    color: ${props => props.theme.colors.darkBlue};
  }
  .col-lg-3 {
    text-align: center;
    p {
      font-weight: 500;
      color: ${props => props.theme.colors.darkBlue};
    }
    img {
      max-width: 150px;
    }
    @media (max-width: 575px) {
      margin-bottom: 24px;
    }
  }
  .resource {
    margin-top: 24px;
    a {
      font-size: 12px;
      color: ${props => props.theme.colors.darkBlue};
      text-decoration: none;
    }
  }
`
